// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_GARMENTS_PO_REQUEST = 'FETCH_GARMENTS_PO_REQUEST';
export const FETCH_GARMENTS_PO_SUCCESS = 'FETCH_GARMENTS_PO_SUCCESS';
export const FETCH_GARMENTS_PO_FAILURE = 'FETCH_GARMENTS_PO_FAILURE';

// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_GARMENTS_PO_STYLE_REQUEST = 'FETCH_GARMENTS_PO_STYLE_REQUEST';
export const FETCH_GARMENTS_PO_STYLE_SUCCESS = 'FETCH_GARMENTS_PO_STYLE_SUCCESS';
export const FETCH_GARMENTS_PO_STYLE_FAILURE = 'FETCH_GARMENTS_PO_STYLE_FAILURE';

// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_GARMENTS_PO_FORMAT_REQUEST = 'FETCH_GARMENTS_PO_FORMAT_REQUEST';
export const FETCH_GARMENTS_PO_FORMAT_SUCCESS = 'FETCH_GARMENTS_PO_FORMAT_SUCCESS';
export const FETCH_GARMENTS_PO_FORMAT_FAILURE = 'FETCH_GARMENTS_PO_FORMAT_FAILURE';

// CREATE PROPERTIES FOR TEAM MASTER
export const CREATE_GARMENTS_PO_REQUEST = 'CREATE_GARMENTS_PO_REQUEST';
export const CREATE_GARMENTS_PO_SUCCESS = 'CREATE_GARMENTS_PO_SUCCESS';
export const CREATE_GARMENTS_PO_FAILURE = 'CREATE_GARMENTS_PO_FAILURE';

//CREATE USER FORM
export const CREATE_USER_FORM_GARMENTS_PO = 'CREATE_USER_FORM_GARMENTS_PO';

// UPDATE PROPERTIES FOR TEAM MASTER
export const UPDATE_GARMENTS_PO_REQUEST = 'UPDATE_GARMENTS_PO_REQUEST';
export const UPDATE_GARMENTS_PO_SUCCESS = 'UPDATE_GARMENTS_PO_SUCCESS';
export const UPDATE_GARMENTS_PO_FAILURE = 'UPDATE_GARMENTS_PO_FAILURE';

// FETCH SINGLE TEAM
export const FETCH_SINGLE_GARMENTS_PO_REQUEST = 'FETCH_SINGLE_GARMENTS_PO_REQUEST';
export const FETCH_SINGLE_GARMENTS_PO_SUCCESS = 'FETCH_SINGLE_GARMENTS_PO_SUCCESS';
export const FETCH_SINGLE_GARMENTS_PO_FAILURE = 'FETCH_SINGLE_GARMENTS_PO_FAILURE';

// DELETE PROPERTIES FOR TEAM MASTER
export const DELETE_GARMENTS_PO_REQUEST = 'DELETE_GARMENTS_PO_REQUEST';
export const DELETE_GARMENTS_PO_SUCCESS = 'DELETE_GARMENTS_PO_SUCCESS';
export const DELETE_GARMENTS_PO_FAILURE = 'DELETE_GARMENTS_PO_FAILURE';

// USERFORM RESET

export const GARMENTS_PO_USERFORM_RESET = 'GARMENTS_PO_USERFORM_RESET';

// navigate to unit component
export const NAVIGATE_GARMENTS_PO_DETAILS = 'NAVIGATE_GARMENTS_PO_DETAILS';
// navigate to company component
export const NAVIGATE_CUTTING_DC = 'NAVIGATE_CUTTING_DC';
export const GARMENTS_PO_USERFORM_NAVIGATE_TO_DETAIL_TAB = 'GARMENTS_PO_USERFORM_NAVIGATE_TO_DETAIL_TAB';
export const GARMENTS_PO_USERFORM_NAVIGATE_TO_DETAIL_REVERSE = 'GARMENTS_PO_USERFORM_NAVIGATE_TO_DETAIL_REVERSE';

// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_GARMENTS_PO_INVOICE_REQUEST = 'FETCH_GARMENTS_PO_INVOICE_REQUEST';
export const FETCH_GARMENTS_PO_INVOICE_SUCCESS = 'FETCH_GARMENTS_PO_INVOICE_SUCCESS';
export const FETCH_GARMENTS_PO_INVOICE_FAILURE = 'FETCH_GARMENTS_PO_INVOICE_FAILURE';

export const RESET_GARMENTS_PO_INVOICE_V2 = 'RESET_GARMENTS_PO_INVOICE_V2';


export const FETCH_GARMENTS_PO_QTY_WITH_SIZE_FOR_PRINT_REQUEST = 'FETCH_GARMENTS_PO_QTY_WITH_SIZE_FOR_PRINT_REQUEST';
export const FETCH_GARMENTS_PO_QTY_WITH_SIZE_FOR_PRINT_SUCCESS = 'FETCH_GARMENTS_PO_QTY_WITH_SIZE_FOR_PRINT_SUCCESS';
export const FETCH_GARMENTS_PO_QTY_WITH_SIZE_FOR_PRINT_FAILURE = 'FETCH_GARMENTS_PO_QTY_WITH_SIZE_FOR_PRINT_FAILURE';




export const CLOSE_BTN_POST_REQUEST_GARMENTS = 'CLOSE_BTN_POST_REQUEST_GARMENTS'
export const CLOSE_BTN_POST_SUCCESS_GARMENTS = 'CLOSE_BTN_POST_SUCCESS_GARMENTS'
export const CLOSE_BTN_POST_FAILURE_GARMENTS = 'CLOSE_BTN_POST_FAILURE_GARMENTS'



export const DELETE_GARMENTS_PO_REQUEST_CALL_OFF = 'DELETE_GARMENTS_PO_REQUEST_CALL_OFF'
export const DELETE_GARMENTS_PO_SUCCESS_CALL_OFF = 'DELETE_GARMENTS_PO_SUCCESS_CALL_OFF'
export const DELETE_GARMENTS_PO_FAILURE_CALL_OFF = 'DELETE_GARMENTS_PO_FAILURE_CALL_OFF'

export const NAVIGATE_GARMENTS_PO = 'NAVIGATE_GARMENTS_PO'

export const NAVIGATE_GARMENTS_PO_PRINT = 'NAVIGATE_GARMENTS_PO_PRINT';

export const SET_RETURNABLE_GRID_NAME_GARMENT_PO_HEADER = 'SET_RETURNABLE_GRID_NAME_GARMENT_PO_HEADER';


export const FETCH_GARMENTS_PO_QTY_WITH_SIZE_FOR_PRINT_RESET = 'FETCH_GARMENTS_PO_QTY_WITH_SIZE_FOR_PRINT_RESET';

export const SET_PENDING_GRID_NAME_RADIO_CHANGE = 'SET_PENDING_GRID_NAME_RADIO_CHANGE';

export const DELETE_CALL_OFF_GARMENTS_PO_REQUEST = 'DELETE_CALL_OFF_GARMENTS_PO_REQUEST';
export const DELETE_CALL_OFF_GARMENTS_PO_SUCCESS = 'DELETE_CALL_OFF_GARMENTS_PO_SUCCESS';
export const DELETE_CALL_OFF_GARMENTS_PO_FAILURE = 'DELETE_CALL_OFF_GARMENTS_PO_FAILURE';

export const HEADER_SEARCH_CALL_ONLOAD = 'HEADER_SEARCH_CALL_ONLOAD';